import { useState } from "react";
import html2pdf from "html2pdf.js";
import './App.css';

const Input = (props) => (
  <input className="border px-2 py-1 w-full rounded" {...props} />
);
const Button = ({ children, ...props }) => (
  <button className="bg-blue-600 text-white px-4 py-2 rounded mt-2" {...props}>
    {children}
  </button>
);
const Card = ({ children }) => (
  <div className="border rounded shadow p-4 mb-4">{children}</div>
);
const CardContent = ({ children }) => <div>{children}</div>;

function App() {
  const [formType, setFormType] = useState("director");
  const [formData, setFormData] = useState({
    companyName: "",
    acn: "",
    OldDirector: "",
    NewDirector: "",
    OldBusinessAddress: "",
    NewAddress: "",
    DobNewDirector: "",
    numShares: "100",
    dateCompanyOpened: "",
    originalShares: "100",
    sharesTransferred: "50",
    shareValue: "1.00", // default to $1.00
    backdate: false,
    customDate: ""
  });
  const [generatedHTML, setGeneratedHTML] = useState("");

   const handleChange = (e) => {
     const { name, value, type, checked } = e.target;
      setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
        }));
      };

      const generateMinutes = () => {
        const d = formData;
        let dateObj;
        if (d.backdate) {
          dateObj = new Date();
          dateObj.setDate(dateObj.getDate() - 28);
        } else if (d.customDate) {
          dateObj = new Date(d.customDate);
        } else {
          dateObj = new Date();
        }
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        const currentDate = `${day}/${month}/${year}`;
        
      

    let html = `
      <div id="pdfContent" style="font-size: 14px; line-height: 1.6">
        <p style="text-align:center; font-weight: bold;">MINUTES OF THE MEETING</p>
        <p style="text-align:center;">${d.companyName} PTY LTD A.C.N. ${d.acn}</p>
        <p>This is a written record of resolution of ${d.companyName} PTY LTD made on the details below.</p>
    `;

    if (formType === "address") {
      html += `
        <p><strong>VENUE:</strong> ${d.OldBusinessAddress}<br/>
        <strong>DATE & TIME:</strong> ${currentDate} 10:00am<br/>
        <strong>CHAIRPERSONS:</strong> ${d.OldDirector}<br/>
        <strong>PRESENT:</strong> ${d.OldDirector}</p>

        <p><strong>TABLED</strong><br/>
        Change of address from ${d.OldDirector} to ${d.NewDirector}.</p>

        <p><strong>RESOLUTIONS:</strong></p>
        <p><strong>Change of Registered Office Address</strong><br/>
        It was agreed that the registered office address will change from ${d.OldBusinessAddress} to ${d.NewAddress}.</p>

        <p><strong>Change of Principal Place of Business</strong><br/>
        It was agreed that the principal place of business address will change from ${d.OldBusinessAddress} to ${d.NewAddress}.</p>

        <p><strong>Change of Officeholder Address</strong><br/>
        It was agreed that the officeholder address will change from ${d.OldBusinessAddress} to ${d.NewAddress}.</p>

        <p><strong>Updating ASIC records</strong><br/>
        It is agreed that Practiced Pty Ltd will update the ASIC records.<br/>
        It is agreed that ASIC records need to be updated.</p>

        <p>Signed as a true and correct record of the resolution.</p>
         <div style="height: 30px;"></div>
        <p>___________________<br/>${d.OldDirector}<br/>Date: ${currentDate}</p>
      `;
    }

    if (formType === "addition") {
      html += `
        <p><strong>VENUE:</strong> ${d.OldBusinessAddress}<br/>
        <strong>DATE & TIME:</strong> ${currentDate} 10:00am<br/>
        <strong>CHAIRPERSONS:</strong> ${d.OldDirector}<br/>
        <strong>PRESENT:</strong> ${d.OldDirector}</p>

        <p><strong>TABLED</strong><br/>
        Appointment of ${d.NewDirector} as Director and Secretary.<br/>
        Transfer of ${d.sharesTransferred} shares from ${d.OldDirector} to ${d.NewDirector}.</p>

        <p><strong>RESOLUTIONS:</strong></p>
        <p><strong>Appointment of New Director and Secretary</strong><br/>
        It has been resolved that ${d.NewDirector} be appointed as a Director and Secretary of the company effective immediately.</p>

        <p><strong>Share Transfer</strong><br/>
        It has been resolved that ${d.sharesTransferred} ordinary shares be transferred from ${d.OldDirector} to ${d.NewDirector}.</p>

        <p><strong>Updating ASIC records</strong><br/>
        It is agreed that Practiced Pty Ltd will update the ASIC records.<br/>
        It is agreed that ASIC records need to be updated.</p>

        <p>Signed as a true and correct record of the resolution.</p>
        <div style="height: 30px;"></div> 
        <p>___________________<br/>${d.OldDirector}<br/>Date: ${currentDate}</p>
        <div style="height: 30px;"></div> 
        <p>___________________<br/>${d.NewDirector}<br/>Date: ${currentDate}</p>

        <div style="page-break-before: always;"></div>
        <p style="text-align:center;"><strong>Consent to act as a Director and Secretary</strong></p>
        <p>I, ${d.NewDirector}, of ${d.NewAddress}, born on ${d.DobNewDirector}, consent to my appointment to act as director and secretary of ${d.companyName} PTY LTD.<br/>
        By executing the constitution, I agree to abide by all the terms of the constitution of ${d.companyName} PTY LTD.</p>
        <div style="height: 30px;"></div> 
        <p>___________________<br/>${d.NewDirector}<br/>Date: ${currentDate}</p>

        <div style="page-break-before: always;"></div>
        <p style="text-align:center;"><strong>Register of Members</strong></p>
        <p style="text-align:center;"><strong>${d.companyName} PTY LTD</strong></p>
        <p style="text-align:center;"><strong>A.C.N. ${d.acn}</strong></p>
        <p>INCORPORATED UNDER THE CORPORATIONS ACT 2001</p>

        <table border="1" cellspacing="0" cellpadding="4" width="100%">
          <tr>
            <td><strong>Name of Shareholder:</strong></td>
            <td>${d.OldDirector}, of ${d.OldBusinessAddress}</td>
          </tr>
          <tr>
            <td><strong>Beneficial owner (if other than registered holder)</strong></td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Type of Shares held</strong></td>
            <td>ORD Shares of $${d.shareValue} each</td>

          </tr>
        </table><br/>

        <table border="1" cellspacing="0" cellpadding="4" width="100%">
          <tr><th>Date of issue / transfer</th><th>Certificate no.</th><th>Number of Shares owned</th><th>Number of shares transferred</th><th>Balance of Shares held by shareholder</th></tr>
          <tr><td>${d.dateCompanyOpened}</td><td>1</td><td>${d.originalShares}</td><td></td><td>${d.originalShares} </td></tr>
          <tr><td>${currentDate}</td><td>2</td><td>${d.originalShares}</td><td> -${d.originalShares - d.sharesTransferred}</td><td>${d.originalShares - d.sharesTransferred} </td></tr>
        </table><br/>

        <table border="1" cellspacing="0" cellpadding="4" width="100%">
          <tr>
            <td><strong>Name of Shareholder:</strong></td>
            <td>${d.NewDirector}, of ${d.NewAddress}</td>
          </tr>
          <tr>
            <td><strong>Beneficial owner (if other than registered holder)</strong></td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Type of Shares held</strong></td>
            <td>ORD Shares of $${d.shareValue} each</td>

          </tr>
        </table><br/>

        <table border="1" cellspacing="0" cellpadding="4" width="100%">
          <tr><th>Date of issue / transfer</th><th>Certificate no.</th><th>Number of Shares owned</th><th>Number of shares transferred</th><th>Balance of Shares held by shareholder</th></tr>
          <tr><td>${currentDate}</td><td>3</td><td>0</td><td>+${d.sharesTransferred}</td><td>${d.sharesTransferred}</td></tr>
        </table>
        
        <div style="height: 30px;"></div> 
        <p>___________________<br/>${d.OldDirector}<br/>Date: ${currentDate}</p>
        <div style="height: 30px;"></div>
        <p>___________________<br/>${d.NewDirector}<br/>Date: ${currentDate}</p>

      `;
    }

    if (formType === "director") {
      html += `
        <p><strong>VENUE:</strong> ${d.OldBusinessAddress}<br/>
        <strong>DATE & TIME:</strong> ${currentDate} 10:00am<br/>
        <strong>CHAIRPERSONS:</strong> ${d.OldDirector}<br/>
        <strong>PRESENT:</strong> ${d.OldDirector},${d.NewDirector}</p>

        <p><strong>TABLED</strong><br/>
        Sale of 100% of shares by ${d.OldDirector} to ${d.NewDirector}<br/>
        Resignation of Director by ${d.OldDirector} and appointment of ${d.NewDirector} as Director and secretary.</p>

        <p><strong>RESOLUTIONS:</strong></p>

        <p><strong>Change of Registered Office Address</strong><br/>
        It was agreed that the registered office address will change from ${d.OldBusinessAddress} to ${d.NewAddress}.</p>

        <p><strong>Change of Principal Place of Business</strong><br/>
        It was agreed that the principal place of business address will change from ${d.OldBusinessAddress} to ${d.NewAddress}.</p>

        <p><strong>Change of Officeholder Address</strong><br/>
        It was agreed that the officeholder address will change from ${d.OldBusinessAddress} to ${d.NewAddress}.</p>


        <p><strong>Sale of Shares</strong><br/>
        It has been resolved that all 100% of shares of ${d.OldDirector} to be sold and transferred to ${d.NewDirector}.</p>
        
        <p><strong>Change of Directors and Company Secretary</strong><br/>
        It has been resolved that ${d.OldDirector} resigns as Director and secretary of the company and ${d.NewDirector} be appointed in replacement.</p>

        <p><strong>Updating ASIC records</strong><br/>
        It is agreed that Practiced Pty Ltd will update the ASIC records.<br/>
        It is agreed that ASIC records need to be updated.</p>

        <p>Signed as a true and correct record of the resolution.</p>
         <div style="height: 30px;"></div>
        <p>___________________<br/>${d.OldDirector}<br/>Date: ${currentDate}</p>
         <div style="height: 30px;"></div>
        <p>___________________<br/>${d.NewDirector}<br/>Date: ${currentDate}</p>

        <div style="page-break-before: always;"></div>
        <p style="text-align:center;"><strong>Resignation as Director and Secretary</strong></p>
        <p>I, ${d.OldDirector}, of ${d.OldBusinessAddress} resign as director and secretary of ${d.companyName} PTY LTD effective ${currentDate}.<br/>
        I accept that I have no claim or right of action of any kind against the Company.<br/>
        By executing the constitution, I agree to withdraw from all the terms and rights of the constitution of ${d.companyName} PTY LTD.</p>
        <p>___________________<br/>${d.OldDirector}<br/>Date: ${currentDate}</p>

        <div style="page-break-before: always;"></div>
        <p style="text-align:center;"><strong>Consent to act as a Director and Secretary</strong></p>
        <p>I, ${d.NewDirector}, of ${d.NewAddress}, born on ${d.DobNewDirector}, consent to my appointment to act as director and secretary of ${d.companyName} PTY LTD.<br/>
        By executing the constitution, I agree to abide by all the terms of the constitution of ${d.companyName} PTY LTD.</p>
         <div style="height: 30px;"></div>
        <p>___________________<br/>${d.NewDirector}<br/>Date: ${currentDate}</p>

        <div style="page-break-before: always;"></div>
        <p style="text-align:center;"><strong>Register of Members</strong></p>
        <p style="text-align:center;"><strong>${d.companyName} PTY LTD</strong></p>
        <p style="text-align:center;"><strong>A.C.N. ${d.acn}</p>
        <p>INCORPORATED UNDER THE CORPORATIONS ACT 2001</p>

        <table border="1" cellspacing="0" cellpadding="4" width="100%">
          <tr>
            <td><strong>Name of Shareholder:</strong></td>
            <td>${d.OldDirector}, of ${d.OldBusinessAddress}</td>
          </tr>
          <tr>
            <td><strong>Beneficial owner (if other than registered holder)</strong></td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Type of Shares held</strong></td>
            <td>ORD Shares of $${d.shareValue} each</td>

          </tr>
        </table><br/>

        <table border="1" cellspacing="0" cellpadding="4" width="100%">
          <tr><th>Date of issue / transfer</th><th>Certificate no.</th><th>Number of Shares owned</th><th>Number of shares transferred</th><th>Balance of Shares held by shareholder</th></tr>
          <tr><td>${d.dateCompanyOpened}</td><td>1</td><td>${d.numShares}</td><td></td><td>0</td></tr>
          <tr><td>${currentDate}</td><td>2</td><td>${d.numShares}</td><td>-${d.numShares}</td><td>0</td></tr>
        </table><br/>

        <table border="1" cellspacing="0" cellpadding="4" width="100%">
          <tr>
            <td><strong>Name of Shareholder:</strong></td>
            <td>${d.NewDirector}, of ${d.NewAddress}</td>
          </tr>
          <tr>
            <td><strong>Beneficial owner (if other than registered holder)</strong></td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Type of Shares held</strong></td>
           <td>ORD Shares of $${d.shareValue} each</td>

          </tr>
        </table><br/>

        <table border="1" cellspacing="0" cellpadding="4" width="100%">
          <tr><th>Date of issue / transfer</th><th>Certificate no.</th><th>Number of Shares owned</th><th>Number of shares transferred</th><th>Balance of Shares held by shareholder</th></tr>
          <tr><td>${currentDate}</td><td>3</td><td>0</td><td>+${d.numShares}</td><td>${d.numShares}</td></tr>
        </table>
        <div style="height: 30px;"></div>
        <p>___________________<br/>${d.OldDirector}<br/>Date: ${currentDate}</p>
         <div style="height: 30px;"></div>
        <p>___________________<br/>${d.NewDirector}<br/>Date: ${currentDate}</p>

        
      `;
    }

    html += `</div>`;
    setGeneratedHTML(html);
  };

  const downloadPDF = () => {
    const element = document.getElementById("pdfContent");
    html2pdf()
      .from(element)
      .set({
        margin: 0.5,
        filename: `Minutes of Meeting - ${formData.companyName}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" }
      })
      .save();
  };

  const fieldVisibility = {
    director: [
      "companyName", "acn", "OldDirector", "NewDirector",
      "OldBusinessAddress", "NewAddress", "DobNewDirector", "numShares", "dateCompanyOpened", "shareValue"
    ],
    address: ["companyName", "acn", "OldDirector", "OldBusinessAddress", "NewAddress"],
    addition: [
      "companyName", "acn", "OldDirector", "NewDirector",
      "OldBusinessAddress", "DobNewDirector", "originalShares", "sharesTransferred", "dateCompanyOpened", "shareValue"
    ]
  };
  
  return (
    <div className="p-4 max-w-3xl mx-auto">
      <Card>
        <CardContent>
          {/* Form Type Selection Area */}
          <div className="form-type-selection">
            <label className="block mb-2 font-medium">Select form type:</label>
            <select
              className="border px-2 py-1 rounded w-full"
              value={formType}
              onChange={(e) => setFormType(e.target.value)}
            >
              <option value="director">Change of Director</option>
              <option value="address">Change of Address</option>
              <option value="addition">Add New Director</option>
            </select>
          </div>
  
{/* Date Options Panel */}
<div className="date-options-panel">
  <h3 className="date-options-title">Date Options</h3>

  <div className="date-options-row">
    {/* Custom date picker */}
    <div className={formData.backdate ? "custom-date-picker disabled" : "custom-date-picker"}>
      <label className="block">Custom date</label>
      <input
        type="date"
        name="customDate"
        value={formData.customDate}
        onChange={handleChange}
        disabled={formData.backdate}
        className="border px-3 py-2 rounded w-full focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    </div>

    {/* Backdate toggle */}
    <label className="backdate-toggle">
      <input
        type="checkbox"
        name="backdate"
        checked={formData.backdate}
        onChange={handleChange}
        className="form-checkbox"
      />
      <span className="backdate-label">Backdate by 28 days</span>
    </label>
  </div>
</div>


  
          <div className="input-grid">
            {Object.entries(formData).map(([key]) => (
              fieldVisibility[formType].includes(key) && (
                <Input
                  key={key}
                  name={key}
                  placeholder={key.replace(/([A-Z])/g, " $1")}
                  onChange={handleChange}
                />
              )
            ))}
          </div>
  
          <div className="button-row">
            <Button onClick={generateMinutes}>Generate Minutes</Button>
            {generatedHTML && <Button onClick={downloadPDF}>Download PDF</Button>}
          </div>
        </CardContent>
      </Card>
  
      {generatedHTML && (
        <Card>
          <CardContent>
            <div className="generated-content" dangerouslySetInnerHTML={{ __html: generatedHTML }} />
          </CardContent>
        </Card>
      )}
    </div>
  );
  
}

export default App;
